import React, { Component } from 'react';
import humidityIcon from '../../../Images/Daikin_Images/icon/Humid.png';

export default class Display_Mp_Cell_AV extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let temp_img_width = (0.1) * this.props.cell_width;
		let font_size = (0.1) * this.props.cell_width;

		let pointInfo = this.props.point_info;
		let displayHumIcon = false;
		let AVValue = null;
		let unitValue = null;

		if (pointInfo.hasOwnProperty('av')) {
			AVValue = pointInfo.av;
		}

		if (pointInfo.hasOwnProperty('unit')) {
			unitValue = pointInfo.unit;
		}

		if(pointInfo.type == 'Dehumi') {
			displayHumIcon = true;
		}

		return (
			<div style={{ whiteSpace: 'nowrap', display: AVValue == null ? 'none' : 'inline-block' }}>
				<img src={humidityIcon} style={{ width: temp_img_width, display: displayHumIcon ? 'inline-block' : 'none' }} />
				<span style={{ fontSize: font_size, display: 'inline-block', whiteSpace: 'nowrap' }}>{AVValue + unitValue}</span>
			</div>
		)
	}
}